import {Component, Plugins} from '@packages/systems/wfdl';
import {namesEqual, qualify} from '@packages/systems/wfdl-Qualified';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';

const standalonePopoverType = qualify(
  Plugins.name('Popover'),
  Component.name('Popover')
);

const isStandalonePopover = (element: ExpressionElement): boolean =>
  namesEqual(element.type, standalonePopoverType);

/**
 * Returns whether an element is a standalone Popover that can be offered as a
 * Link Popover target.
 */
export const isPopoverTarget = (element: ExpressionElement): boolean =>
  isStandalonePopover(element);

/**
 * Returns whether an element type is a standalone Popover, for callers that
 * keep only the type of a target.
 */
export const isPopoverTargetType = (type: ExpressionElement['type']): boolean =>
  namesEqual(type, standalonePopoverType);
